/* baitishk-bundle.js — Smart variant auto-match (fully automatic, no UI)
   Strategy:
     1. On render: match anchor variant options against each companion's variants
        (case-insensitive exact match per option value; word-level partial match
        as fallback for compound names like "Sand Beige" ↔ "Beige")
     2. When customer changes anchor variant, ALL companions re-match automatically
        and the per-companion thumb / variant name / price update in place
     3. Bundle total and Add-bundle button data stay in sync
*/
(function () {
  'use strict';

  function init() {
    var bundle = document.querySelector('[data-bundle-block]');
    if (!bundle) return;

    var anchorDataEl = bundle.querySelector('[data-bundle-anchor]');
    if (!anchorDataEl) return;

    var anchorData;
    try { anchorData = JSON.parse(anchorDataEl.textContent); }
    catch (e) { console.warn('[Bundle] Bad anchor data', e); return; }

    /* Build companion model */
    var companions = [];
    bundle.querySelectorAll('[data-companion-id]').forEach(function (el) {
      var dataEl = el.querySelector('[data-bundle-companion-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); }
      catch (e) { return; }
      if (!variants || !variants.length) return;

      companions.push({
        el: el,
        id: el.dataset.companionId,
        variants: variants,
        selectedVariant: variants[0],
        priceEl: el.querySelector('[data-companion-price]'),
        thumbEl: el.querySelector('[data-companion-thumb] img'),
        infoEl: el.querySelector('[data-companion-variant-title]')
      });
    });

    if (!companions.length) return;

    /* === MATCHING ENGINE === */
    function findBestMatch(variants, anchorOptions) {
      var anchorLower = (anchorOptions || []).map(function (o) {
        return (o || '').toString().toLowerCase().trim();
      });

      var bestScore = -1;
      var bestVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;

        var score = 0;
        var optList = v.options || [];
        for (var j = 0; j < optList.length; j++) {
          var optLower = (optList[j] || '').toString().toLowerCase().trim();
          if (!optLower) continue;
          if (anchorLower.indexOf(optLower) !== -1) {
            score += 2; /* exact match */
          } else {
            /* word-level partial match: e.g. "Sand Beige" matches "Beige" */
            for (var k = 0; k < anchorLower.length; k++) {
              var anchorWords = anchorLower[k].split(/\s+/);
              var optWords = optLower.split(/\s+/);
              for (var w = 0; w < optWords.length; w++) {
                if (optWords[w].length >= 4 && anchorWords.indexOf(optWords[w]) !== -1) {
                  score += 1;
                  break;
                }
              }
            }
          }
        }

        if (score > bestScore) {
          bestScore = score;
          bestVariant = v;
        }
      }

      /* Fallback: first available variant */
      if (!bestVariant) {
        for (var i2 = 0; i2 < variants.length; i2++) {
          if (variants[i2].available) { bestVariant = variants[i2]; break; }
        }
      }
      return bestVariant;
    }

    /* === UI SYNC === */
    function applyMatch(companion) {
      var v = companion.selectedVariant;
      if (!v) return;
      if (companion.priceEl) companion.priceEl.textContent = formatMoney(v.price);
      if (companion.thumbEl && v.featured_image) {
        companion.thumbEl.src = v.featured_image;
      }
      if (companion.infoEl) {
        var displayTitle = v.title && v.title !== 'Default Title' ? v.title : '';
        companion.infoEl.textContent = displayTitle;
      }
    }

    function updateTotal() {
      var anchorVariant = anchorData.variants.find(function (v) {
        return String(v.id) === String(anchorData.selected_variant_id);
      });
      var total = anchorVariant ? anchorVariant.price : 0;
      companions.forEach(function (c) {
        if (c.selectedVariant) total += c.selectedVariant.price;
      });
      var totalEl = bundle.querySelector('[data-bundle-total]');
      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    function updateAddButton() {
      var btn = bundle.querySelector('[data-bundle-add]');
      if (!btn) return;
      var ids = companions
        .filter(function (c) { return c.selectedVariant && c.selectedVariant.available; })
        .map(function (c) { return c.selectedVariant.id; })
        .join(',');
      btn.dataset.companionVariants = ids;
    }

    function matchAll(anchorVariant) {
      if (!anchorVariant) return;
      companions.forEach(function (c) {
        var match = findBestMatch(c.variants, anchorVariant.options);
        if (match) {
          c.selectedVariant = match;
          applyMatch(c);
        }
      });
      updateTotal();
      updateAddButton();
    }

    /* === INITIAL MATCH === */
    var initialAnchor = anchorData.variants.find(function (v) {
      return String(v.id) === String(anchorData.selected_variant_id);
    });
    matchAll(initialAnchor);

    /* === ANCHOR VARIANT CHANGE LISTENER === */
    var mainForm = document.querySelector('form[action*="/cart/add"]:not([action*="sticky"])') ||
                   document.querySelector('form[action*="/cart/add"]');

    function syncAnchor() {
      if (!mainForm) return;
      var input = mainForm.querySelector('input[name="id"]');
      if (!input) return;
      var newId = input.value;
      if (!newId || String(newId) === String(anchorData.selected_variant_id)) return;
      anchorData.selected_variant_id = newId;
      var newVariant = anchorData.variants.find(function (v) {
        return String(v.id) === String(newId);
      });
      if (newVariant) matchAll(newVariant);
    }

    if (mainForm) {
      mainForm.addEventListener('change', syncAnchor);
      document.addEventListener('variant:change', syncAnchor);
      document.addEventListener('variant:changed', syncAnchor);
      document.addEventListener('variantChange', syncAnchor);

      /* Polling fallback for themes that don't dispatch events */
      var lastSeen = String(anchorData.selected_variant_id);
      setInterval(function () {
        var input = mainForm.querySelector('input[name="id"]');
        if (input && String(input.value) !== lastSeen) {
          lastSeen = String(input.value);
          syncAnchor();
        }
      }, 600);
    }

    function formatMoney(cents) {
      var format = (window.themeGlobalVariables
        && window.themeGlobalVariables.settings
        && window.themeGlobalVariables.settings.money_format) || '{{amount}}';
      var n = (cents / 100);
      var dollars = n.toFixed(3);
      var formatted = format
        .replace('{{amount}}', dollars)
        .replace('{{amount_no_decimals}}', Math.round(n).toString())
        .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(n).toString());
      return formatted.replace(/<[^>]*>/g, '').trim();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
